import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
// const express = require('express')
// const cors = require('cors')
// const app = express()

// const corsOptions = {
//   origin:'https://app.zasway.com', 
//   credentials:true,            //access-control-allow-credentials:true
//   optionSuccessStatus:200,
//   methods: "GET, POST"
// }
// app.use(cors(corsOptions))
// app.use(cors({ origin: true }))
//     app.use((res, next) => {
//       res.setHeader("Access-Control-Allow-Origin", "*")
//       res.setHeader("Access-Control-Allow-Credentials", "true")
//       res.setHeader("Access-Control-Max-Age", "1800")
//       res.setHeader("Access-Control-Allow-Headers", "content-type")
//       res.setHeader(
//             "Access-Control-Allow-Methods",
//             "PUT, POST, GET, DELETE, PATCH, OPTIONS"
//       )
//       next()
//       })

// const express = require("express")
// const app = express()
// const cors = require("cors")

// // app.use(express.json())
// app.use(cors())

// const header = {
//   origin: "*"
// }

let headers = ''

function headersSet() {
  const headersQ = window.localStorage.getItem('Headers')
  headers = JSON.parse(headersQ)
}

export const UpdateCheckoutStatus = createAsyncThunk('appPassenger/UpdateCheckoutStatus', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/UpdateCheckoutPaymentStatus', ClientId, { mode: 'cors' })
  return response.data
})

export const getstaffList = createAsyncThunk('Client/getDriverUsersList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetStaffList', params, { mode: 'cors' })
  return response.data
})

export const getDataBooking = createAsyncThunk('client/getDataBooking', async (params) => {
  // headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBooking', params,
    // { headers }, 
    { mode: 'cors' })
  // if (response.data.code === undefined) {
  return {
    params,
    data: response.data,
    allData: response.data,
    totalPages: 10
  }
  // } else {
  //      
  //       return {
  //         data : response.data.code
  //       }
  //     }
})

export const getBookingQuoteByBookingId = createAsyncThunk('client/getBookingQuoteByBookingId', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingQuoteByBookingId', params, { mode: 'cors' })
  return response.data
})

// export const UpdateCheckoutStatus = createAsyncThunk('appPassenger/UpdateCheckoutStatus', async (ClientId) => {

//   const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/UpdateCheckoutPaymentStatus', ClientId, { mode: 'cors' })
//   return response.data
// })

export const getDataBookings = createAsyncThunk('Client/getDataBookings', async (params) => {
  // try {
  // headersSet()
  // console.log("Headers in Booking===>>", headers)
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummary', params, { mode: 'cors' })
  // console.log(response)np 
  // if (response.data.code === undefined) {
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
  //  } else {
  //      return {
  //        data : response.data.code
  //      }
  //  }
  // } catch (e) {
  //   // console.log(e)
  //   return {
  //     data: e
  //   }
  // }
})

export const getTableSummaryByClientID = createAsyncThunk('Client/getTableSummaryByClientID', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryByClientID', {
    CompanyID: params.companyID,
    ClientID: params.id,
    ID: params.ID || 0,
    q: params.q || "",
    page: params.page || 1,
    perPage: params.perPage || 10,
    SortColumn: params.sortColumn || "id",
    SortType: params.sortType || "desc"
  }, { mode: 'cors' })
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, { mode: 'cors' })
  return response.data
})

export const getDataBookingsFilter = createAsyncThunk('Booking/getDataBookingsFilter', async (paramss) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingFilter', paramss, { mode: 'cors' })
  return {
    paramss,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const updatePaymentStatusOfBooking = createAsyncThunk('Booking/updatePaymentStatusOfBooking', async (paramss) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdatePaymentStatusOfBooking', paramss, { mode: 'cors' })
  return {
    paramss,
    data: response.data.message
  }
})

export const getBookingDateFilter = createAsyncThunk('Client/getBookingDateFilter', async (params) => {
  // const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryBookingDateFilter', params, {mode:'cors'})
  // const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingFilter', params, {mode:'cors'})
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingFiltertestting', params, { mode: 'cors' })
  // const data = response.data.slice(0, 10)
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getDataBookingParams = createAsyncThunk('/Bookings/getDataBookingParams', (dataParams) => {
  return { data: dataParams }
})

export const getSubCompanyList = createAsyncThunk('Client/getSubCompanyList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetSubCompanyList')
  return response.data
})

export const getBookingZoneDesc = createAsyncThunk('Client/getSubCompanyList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetZoneNameDescription', params, { mode: 'cors' })
  return response.data
})

export const GetEmails = createAsyncThunk('appPassenger/GetEmails', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingEmailAddresses', ClientId, { mode: 'cors' })
  return response.data
})

export const GetEmailswithIds = createAsyncThunk('appPassenger/GetEmailswithIds', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingEmailAddressesForChangings', ClientId, { mode: 'cors' })
  return response.data
})

export const AddPassengerCard = createAsyncThunk('appCreditCardsBooking/AddPassengerCard', async (GetCCDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/WeBookerPaymentTransaction', GetCCDetails, { mode: 'cors' })
  return response.data
})

export const SendSMSToDriver = createAsyncThunk('appPassenger/SendSMSToDriver', async (ClientId) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/SendSMSToDriverwithoutBID', ClientId, { mode: 'cors' })
  return response.data
})

export const getPriorityLst = createAsyncThunk('client/getPriorityList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPriorityList')
  return response.data
})

export const getInvoicePeriodList = createAsyncThunk('Client/getInvoicePeriodList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoicePeriodList')
  return response.data
})

export const getInvoiceSplitList = createAsyncThunk('Client/getInvoiceSplitList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceSplitList')
  return response.data
})

export const getInvoiceGroupList = createAsyncThunk('Client/getInvoiceGroupList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceGroupList')
  return response.data
})

export const getTaxList = createAsyncThunk('Client/getTaxList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList', params, { mode: 'cors' })
  return response.data
})

export const getPaymentMethodList = createAsyncThunk('Client/getPaymentMethodList', async (params) => {
  const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID }, { mode: 'cors' })
  return response.data
})

export const getVehicleTypeList = createAsyncThunk('Client/getVehicleTypeList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, { mode: 'cors' })
  return response.data
})

export const getVehicleTypeListCP = createAsyncThunk('Client/getVehicleTypeList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeListForBookingIfClientPortal', params, { mode: 'cors' })
  return response.data
})
export const getBookingSourceListCP = createAsyncThunk('Client/getBookingSourceList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetBookingSourceListForBookingIfPaymentMethodIsCard', params, { mode: 'cors' })
  return response.data
})

export const addBookingSource = createAsyncThunk('Client/addBookingSource', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/AddBookingSource', params, { mode: 'cors' })
  return response.data
})
export const getCurrencyList = createAsyncThunk('Client/getCurrencyList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetCurrencyList')
  return response.data
})

export const getPricingModalList = createAsyncThunk('Client/getPricingModalList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModalList')
  return response.data
})

export const getPricingModeList = createAsyncThunk('Client/getPricingModeList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModeList')
  return response.data
})

export const getGraceWaitingList = createAsyncThunk('Client/getGraceWaitingList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetGraceWaitingList')
  return response.data
})

export const getDocumentTypeList = createAsyncThunk('Client/getDocumentTypeList', async () => {
  const response = await axios.get('https://api.zasway.com:8443/Common/GetDocumentTypeList')
  return response.data
})

export const getTagList = createAsyncThunk('Client/getTagList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTagList')
  return response.data
})

export const getClientList = createAsyncThunk('appPassenger/getClientList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
  return response.data
})

export const GetCodeValidation = createAsyncThunk('booking/GetCodeValidation', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetCodeValidation', params, { mode: 'cors' })
  return response.data
})

export const resolveMarketingReferral = createAsyncThunk('booking/resolveMarketingReferral', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/ResolveMarketingReferral', params, { mode: 'cors' })
  return response.data
})

export const SendUpdatedBookingDataToAPI = createAsyncThunk('booking/addUpdatedBookingDataInHistoryLog', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/AddUpdatedBookingDataInHistoryLog', params, { mode: 'cors' })
  return response.data
})

export const getPassengerList = createAsyncThunk('appPassenger/getPassengerList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList', params, { mode: 'cors' })
  return response.data
})

export const getSearchedPassenger = createAsyncThunk('Common/getSearchedPassenger', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetSearchedPassenger', params, { mode: 'cors' })
  return response.data
})

export const sendEmailBookingRecipt = createAsyncThunk('Common/getSearchedClient', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/SendReceiptEmail', params, { mode: 'cors' })
  return response.data
})

// export const getBookingClientRef = createAsyncThunk('appPassenger/getBookingClientRef', async () => {
//   const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingClientReferencesDetails')
//   return response.data
// })

export const checkBookingToken = createAsyncThunk('Client/Create', async (params) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Booking/checkBookingToken', params, { headers }, { mode: 'cors' })
  return {
    status: response.status,
    code: response.data.code ?? response.data.Code,
    message: response.data.message ?? response.data.Message
  }
})

export const getClientPassengerList = createAsyncThunk('appPassenger/getClientPassengerList', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetClientPassengerList', ClientId, { mode: 'cors' })
  return response.data
})

export const getPassengerEmailID = createAsyncThunk('appPassenger/getPassengerEmailID', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetPassengerEmailAddress', ClientId, { mode: 'cors' })
  return response.data
})

export const getApprovedExpenses = createAsyncThunk('appPassenger/getApprovedExpenses', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/IsBookingExpenseApproved', params, { mode: 'cors' })
  return response.data
})

export const sendConfirmationEmail = createAsyncThunk('appPassenger/sendConfirmationEmail', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/SendConfirmationEmail', ClientId, { mode: 'cors' })
  return response.data
})

export const LoadEmailddl = createAsyncThunk('appPassenger/LoadEmailddl', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetDDLEmailAgainstPassenger', ClientId, { mode: 'cors' })
  return response.data
})

export const sendPAymentEmail = createAsyncThunk('appPassenger/sendConfirmationEmail', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/SendEmailPaymentLink', ClientId, { mode: 'cors' })
  return response.data
})

export const SetDataofResetBooking = createAsyncThunk('appPassenger/SetDataofResetBooking', async (ClientId) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateDataofResetBooking', ClientId, { mode: 'cors' })
  return response.data
})

export const sendConfirmationSMS = createAsyncThunk('appPassenger/sendConfirmationSMS', async (ClientId) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/SendConfirmationSMS', ClientId, { mode: 'cors' })
  return response.data
})

export const getDurationList = createAsyncThunk('appPassenger/getDurationList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDurationList')
  return response.data
})

export const getFlightDetails = createAsyncThunk('appPassenger/getFlightDetails', async (id) => {
  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/GetFlightDetails', id, { mode: 'cors' })
  return response.data
})

export const getAdditionalCharges = createAsyncThunk('Common/getAdditionalCharges', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetAdditionalCharges', params, { mode: 'cors' })
  return response.data
})

export const getFlightApi = createAsyncThunk('appPassenger/getFlightApi', async (id) => {
  const response = await axios.post('https://api.zasway.com:8443/Flight/GetFlightDetails', id, { mode: 'cors' })
  return response.data
})

export const getFlightApiFlightCheck = createAsyncThunk('appPassenger/getFlightApiFlightCheck', async (id) => {
  const response = await axios.post('https://api.zasway.com:8443/Flight/GetFlightDetailsFlightCheck', id, { mode: 'cors' })
  return response.data
})

// export const getUser = createAsyncThunk('appUsers/getUser', async id => {
//   const response = await axios.get('https://api.zasway.com:8443/api/users/user', { id })
//   return response.data.user
// })

export const GetVehicle = createAsyncThunk('appDriver/GetVehicleList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleTypeList', { mode: 'cors' })
  return response.data
})

export const GetBooker = createAsyncThunk('appDriver/GetBookerList', async (GetBooker) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookerList', GetBooker, { mode: 'cors' })
  return response.data
})

export const GetBookerListByClient = createAsyncThunk('appDriver/GetBookerListByClient', async (GetBooker) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookerListByClient', GetBooker, { mode: 'cors' })
  return response.data
})

export const getPassengerCreditCardList = createAsyncThunk('appDriver/GetPassengerCreditCardList', async (CC) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerClientCreditCardList', CC, { mode: 'cors' })
  return response.data
})

export const GetExclusion = createAsyncThunk('appDriver/GetExclusionList', async (GetExclusion) => {
  const response = await axios.post('https://api.zasway.com:8443/Exclusion/GetExclusionList', GetExclusion, { mode: 'cors' })
  return response.data
})

export const getExpenseTypeList = createAsyncThunk('appDriver/getExpenseTypeList', async (GetExpenseTypeList) => {
  const response = await axios.post('https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeList', GetExpenseTypeList, { mode: 'cors' })
  return response.data
})

export const getBookingJourneyWaitTime = createAsyncThunk('appDriver/getBookingJourneyWaitTime', async (booking) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingJourneyWaitTime', booking, { mode: 'cors' })
  return response.data
})

export const getBookingExpense = createAsyncThunk('appDriver/getBookingExpense', async (GetExpenseList) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryBookingExpense', GetExpenseList, { mode: 'cors' })
  return response.data
})

export const getExpenseDocumentsByExpenseId = createAsyncThunk('appDriver/getExpenseDocumentsByExpenseId', async (payload) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetExpenseDocumentsByExpenseId', payload, { mode: 'cors' })
  return response.data
})

export const getBookingAdditionalCharges = createAsyncThunk('appDriver/getBookingAdditionalCharges', async (GetExpenseList) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingAdditionalCharges', GetExpenseList, { mode: 'cors' })
  return response.data
})

export const getExpenseTypeTax = createAsyncThunk('appDriver/getExpenseTypeTax', async (GetExpenseTypeList) => {
  const response = await axios.post('https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeTax', GetExpenseTypeList, { mode: 'cors' })
  return response.data
})

export const getGetTagDetail = createAsyncThunk('appDriver/getGetTagDetail', async (tag) => {
  const response = await axios.post('https://api.zasway.com:8443/Tag/getGetTagDetail', tag, { mode: 'cors' })
  return response.data
})

export const getPassengerBookingHistory = createAsyncThunk('Client/GetPassengerBookingHistory', async (Passenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerBookingHistory', Passenger, { mode: 'cors' })
  return response.data
})

export const getDurationforMinHours = createAsyncThunk('Booking/GetDurationListMinHours', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetDurationListMinHours', params, { mode: 'cors' })
  return response.data
})

export const getPassengerClientID = createAsyncThunk('Client/GetPassengerClientID', async (PassengerID) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerClientID', PassengerID, { mode: 'cors' })
  return response.data
})

export const getPassengerNote = createAsyncThunk('Client/GetPassengerNote', async (Passenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerNote', Passenger, { mode: 'cors' })
  return response.data
})

export const getClientNote = createAsyncThunk('Client/GetClientNote', async (Client) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientNote', Client, { mode: 'cors' })
  return response.data
})

export const getHydeParkClientIDByExactAddress = createAsyncThunk('KnownLocation/GetHydeParkClientIDByExactAddress', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/KnownLocation/GetHydeParkClientIDByExactAddress', params, { mode: 'cors' })
  return response.data
})

export const getBookingQuote = createAsyncThunk('Client/GetBookingQuote', async (Client) => {
  
  const { signal, ...data } = Client
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingQuote', data, { mode: 'cors', signal })
  return response.data
})

export const getDefaultPricingModelIDByCompany = createAsyncThunk('Client/getDefaultPricingModelIDByCompany', async (Client) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDefaultPricingModelIDByCompany', Client, { mode: 'cors' })
  return response.data
})

export const getBookingFormSetting = createAsyncThunk('Client/GetBookingFormSetting', async (booking) => {
  const response = await axios.post('https://api.zasway.com:8443/BookingFormSetting/GetBookingFormSetting', booking, { mode: 'cors' })
  return response.data
})

export const getConfirmationWebBookerBookingDetails = createAsyncThunk('Client/GetBookingFormSetting', async (booking) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetConformationWebBookerBookingDetails', booking, { mode: 'cors' })
  return response.data
})

export const CreateKnownLocation = createAsyncThunk('FlightDetails/CreateKnownLocation', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/CreateKnownLocation', params, { mode: 'cors' })
  return response.data
})

export const GetGoogleLocationDetails = createAsyncThunk('FlightDetails/GetGoogleLocationDetails', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/GetGoogleLocationDetails', params, { mode: 'cors' })
  return response.data
})

export const GetPlaceDetails = createAsyncThunk('FlightDetails/GetPlaceDetails', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/GetPlaceDetails', {
    PlaceId: params.placeId,
    CompanyId: params.companyId
  }, { mode: 'cors' })
  return response.data
})

export const GetCardValidation = createAsyncThunk('Client/GetCardValidation', async (booking) => {
  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/CheckCardValidityAndDetailsForBooking', booking, { mode: 'cors' })
  return response.data
})

export const addBooking = createAsyncThunk('Client/Create', async (Booking) => {
 
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Booking/Create', Booking, { headers }, { mode: 'cors' })
  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const EditBooking = createAsyncThunk('Client/Edit', async (Booking) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Booking/Update', Booking, { headers }, { mode: 'cors' })
  // Keep the existing token handling, but preserve business errors for the form popup.
  if (response.data.code === 400 || response.data.code === 401) {
    return {
      data: response.data.code
    }
  }
  return {
    data: response
  }
})

export const getSearchedClient = createAsyncThunk('Common/getSearchedClient', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetSearchedClient', params, { mode: 'cors' })
  return response.data
})

export const getClientCommission = createAsyncThunk('Client/getClientCommission', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientCommission', params, { mode: 'cors' })
  return response.data
})

export const NewGetSearchedClient = createAsyncThunk('Common/NewGetSearchedClient', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/NewGetSearchedClient', params, { mode: 'cors' })
  return response.data
})

export const addDocument = createAsyncThunk('Client/CreateDocument', async (Document) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/Create', Document, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }, { mode: 'cors' })
  return response
})

export const EditClient = createAsyncThunk('Client/Update', async (Client) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/Update', Client, { mode: 'cors' })
  return response
})

export const GetPassengerWebBooker = createAsyncThunk('Booking/GetPassengerWebBooker', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetPassengerForWebBooker', params, { mode: 'cors' })
  return response
})

export const getAllData = createAsyncThunk('Client/GetTableSummary', async (GetClient) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', GetClient, { mode: 'cors' })
  return response.data
})

export const getClientNotifications = createAsyncThunk('Client/GetTableSummary', async (GetClient) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetNotificationsForBookingClient', GetClient, { mode: 'cors' })
  return response.data
})

export const setprevClientID = createAsyncThunk('Client/setprevClientID', async (data) => {
  return data
})

export const getData = createAsyncThunk('Client/getData', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { mode: 'cors' })
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getClient = createAsyncThunk('Client/getClient', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { mode: 'cors' })
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async () => {
  const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteClient = createAsyncThunk('Client/Delete', async (id, { dispatch, getState }) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/Delete', id, { mode: 'cors' })
  await dispatch(getData(getState().clients.params))
  return response
})

export const getClientStats = createAsyncThunk('Client/GetClientStatistics', async (GetClient) => {
  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientStatistics', GetClient, { mode: 'cors' })
  return response.data
})

export const getAddressPredictions = createAsyncThunk('Client/getAddressPredictions', async (SearchKeyWord) => {
  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/GetPostCode', SearchKeyWord, { mode: 'cors' })
  return response.data
})

export const getKnownLocationsList = createAsyncThunk('booking/getKnownLocationsList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/KnownLocation/GetKnownLocations', params, { mode: 'cors' })
  return response.data
})

export const getAndSetBookingDataForWebBooker = createAsyncThunk('Client/getAndSetBookingDataForWebBooker', async (data) => {
  return data
})

export const BookerFlagCall = createAsyncThunk('Client/BookerFlagCall', async (data) => {
  return data
})

export const clearStates = createAsyncThunk('Client/getAddressPredictions', async () => {
  return true
})

export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, { mode: 'cors' })
  return response.data
})

export const getBookingStatusList = createAsyncThunk('appCreditCardsBooking/GetBookingStatusesList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDispatchBookingStatusAllList')
  return response.data
})

export const GetWebBookerUserID = createAsyncThunk('appCreditCardsBooking/GetBookingStatusesList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetWebBookerUserID')
  return response.data
})

export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, { mode: 'cors' })
  return response.data
})

export const getLicenseType = createAsyncThunk('appBookingValidation/getLicenseType', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetLicenseTypeList', params, { mode: 'cors' })
  return response.data
})

export const getUpdateBookingStatus = createAsyncThunk('Booking/getUpdateBookingStatus ', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingStatus', params, { mode: 'cors' })
  return response.data
})

export const updateBookingStatusSimple = createAsyncThunk('Booking/updateBookingStatusSimple', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingStatusSimple', params, { mode: 'cors' })
  return response.data
})

export const getClientListFilter = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
  return response.data
})

export const getPassengerListFilter = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList', params, { mode: 'cors' })
  return response.data
})

export const getFixedPricingCommission = createAsyncThunk('FixedPricing/GetFixedPricingCommission', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetFixedPricingCommission', params, { mode: 'cors' })
  return response.data
})

export const BookingSlice = createSlice({
  name: 'client',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    prevClientID: 0,
    selecetedDriver: [],
    Loader: false,
    khangul: false,
    bookingFilterParams: [],
    webBookerData: [],
    LoderForWebBooker: false,
    dataEmails: [],
    bookerFlagcall: false,
    InValidateparams: {},
    InValidateData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(clearStates.fulfilled, (state) => {
        state.data = []
        state.total = 1
        state.params = {}
        state.allData = []
        state.selectedUser = null
        state.prevClientID = 0
      })

      .addCase(getDataBookingParams.fulfilled, (state, action) => {
        state.bookingFilterParams = action.payload.data
      })

      .addCase(BookerFlagCall.fulfilled, (state, action) => {
        state.bookerFlagcall = action.payload
      })

      .addCase(GetEmails.fulfilled, (state, action) => {
        state.dataEmails = action.payload
      })

      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })

      .addCase(getBookingQuote.pending, (state) => {
        state.Loader = true
      })

      .addCase(getBookingQuote.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(getBookingQuote.rejected, (state) => {
        state.Loader = false
      })

      .addCase(GetCodeValidation.pending, (state) => {
        state.Loader = true
      })

      .addCase(GetCodeValidation.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(GetCodeValidation.rejected, (state) => {
        state.Loader = false
      })

      .addCase(setprevClientID.fulfilled, (state, action) => {
        state.prevClientID = action.payload
      })

      .addCase(getDataBookings.pending, (state) => {
        state.Loader = true
      })

      .addCase(getDataBookings.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.Loader = false
      })

      .addCase(getDataBookings.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getTableSummaryByClientID.pending, (state) => {
        state.Loader = true
      })

      .addCase(getTableSummaryByClientID.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.Loader = false
      })

      .addCase(getTableSummaryByClientID.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getBookingDateFilter.pending, (state) => {
        state.Loader = true
      })

      .addCase(getBookingDateFilter.fulfilled, (state, action) => {
        state.Loader = false
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })

      .addCase(getBookingDateFilter.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })

      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

      .addCase(getClient.fulfilled, (state, action) => {
        state.selectedUser = action.payload.data[0]
      })

      .addCase(getDataBookingsFilter.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })

      .addCase(getSearchedClient.pending, (state) => {
        state.Loader = true
      })

      .addCase(getSearchedClient.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(getSearchedClient.rejected, (state) => {
        state.Loader = false
      })

      .addCase(NewGetSearchedClient.pending, (state) => {
        state.Loader = true
      })

      .addCase(NewGetSearchedClient.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(NewGetSearchedClient.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getSearchedPassenger.pending, (state) => {
        state.Loader = true
      })

      .addCase(getSearchedPassenger.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(getSearchedPassenger.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getFlightApi.pending, (state) => {
        state.Loader = true
      })

      .addCase(getFlightApi.fulfilled, (state) => {
        state.Loader = false
      })

      .addCase(getFlightApi.rejected, (state) => {
        state.Loader = false
      })

      .addCase(getAndSetBookingDataForWebBooker.fulfilled, (state, action) => {
        state.webBookerData = action.payload
      })

      .addCase(getConfirmationWebBookerBookingDetails.pending, (state) => {
        state.LoderForWebBooker = true
      })

      .addCase(getConfirmationWebBookerBookingDetails.fulfilled, (state) => {
        state.LoderForWebBooker = false
      })

      .addCase(getConfirmationWebBookerBookingDetails.rejected, (state) => {
        state.LoderForWebBooker = false
      })

      .addCase(addBooking.pending, (state) => {
        state.LoderForWebBooker = true
      })

      .addCase(addBooking.fulfilled, (state) => {
        state.LoderForWebBooker = false
      })

      .addCase(addBooking.rejected, (state) => {
        state.LoderForWebBooker = false
      })
  }
})

export default BookingSlice.reducer
